// extracted by mini-css-extract-plugin
export default {"description":"style_description__Zj6on","fade-in":"style_fade-in__0IggA","top":"style_top__0e6S5","image":"style_image__lcKFW"};